export default __webpack_public_path__ + "static/media/Edit-documentation.84d0309f.md";